import { AfterViewInit, Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { fadeIn, fadeOut } from 'src/app/animations';
import { FormTemplate } from 'src/app/models/forms/form-template.model';
import { ReactChildComponentView } from 'src/app/add-ons/react-form/react-form-schema/react-form-schema.js';
import { updateDefaultSchema } from 'src/app/add-ons/react-form/redux/list.action';
import { ValueStore } from 'src/app/add-ons/react-form/redux/list.store';
import { StoreObject } from 'src/app/add-ons/react-form/redux/storeObject';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'form-viewer',
	templateUrl: './form-viewer.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: [
		'../../../assets/themes/bootstrap-3.3.7/css/bootstrap.min.css',
		'./form-viewer.component.scss', 
		'../stylesheets/job-actions.scss', 
		'../stylesheets/job-main.scss', 
		'../stylesheets/job-inputs.scss', 
		'../stylesheets/forms-container.scss',		
	],

	animations: [fadeIn(200)]
})
export class FormViewerComponent implements AfterViewInit {
 
	@ViewChild("submitButton", { read: ElementRef }) submitButton: ElementRef;
	@Input() public formTemplate: FormTemplate;
	@Input() public submitFormCallback: (storeState: StoreObject) => void;
	@Input() public isReadOnly: boolean = false;

	@Output() public afterLoading: EventEmitter<FormViewerComponent> = new EventEmitter<FormViewerComponent>();

	private store: ValueStore;

	constructor(
		private injector: Injector
	) {
		this.initStore();
	}
	get formId(): string {
		return `react-component-container-${this.formTemplate.formTemplateId}`;
	}
	ngAfterViewInit(): void {
		this.openForm(); 
		this.afterLoading.emit(this);		
		if(this.isReadOnly) {
			document.querySelectorAll(`#${this.formId} select`).forEach((formElement) => {
				if(!formElement.hasAttribute('disabled')) {
					formElement.setAttribute('disabled', 'true');
				}
			});
		}		
		
	}

	private initStore(): void {
		const storeObject = new StoreObject();
		storeObject.Schema = {};
		storeObject.UiSchema = {};
		this.store = new ValueStore(storeObject);
	}

	private openForm(): void {		
		ReactChildComponentView.initialize(this.store, this.formId, this.injector, Date.now(), this.isReadOnly ? void 0 : this.submitFormCallback.bind(this, this.store));
		this.store.dispatch(updateDefaultSchema(this.formTemplate.jsonSchemaObj, this.formTemplate.defaultUISchemaObj, this.formTemplate.formDataObj, [], this.isReadOnly));					
	}

	public submit(): void {
		this.submitButton.nativeElement.click();
	}
}
